import React from 'react';
import { useConnect } from 'redux-bundler-hook';
import DefaultTemplate from 'root/components/templates/Default';

const IFRAME_STYLE = { height: '100%', width: '100%' };

const Team: React.FC = () => {
  const { routeParams } = useConnect('selectRouteParams');
  const {
    fullUser: { id },
  } = useConnect('selectFullUser');

  const { organizationId } = routeParams;
  const iframeUrl =
    process.env.NODE_ENV === 'development'
      ? `http://${window.location.hostname}:4000/embedded/messaging/settings/twilio_registrations?organization_id=${organizationId}&user_id=${id}`
      : `${window.location.origin}/embedded/messaging/settings/twilio_registrations?organization_id=${organizationId}&user_id=${id}`;

  return (
    <DefaultTemplate title="Compliance" contentPadding={0}>
      <iframe
        title="10dlc-compliance-form"
        src={iframeUrl}
        style={IFRAME_STYLE}
      />
    </DefaultTemplate>
  );
};

export default Team;
